export interface MenuItemConfig {
  label: string;
  icon: string;
  activeIcon?: string;
  path: string;
  children?: MenuItemConfig[];
  roles?: string[]; // 'owner' | 'admin' | 'client' | etc.
  hideOnMobile?: boolean;
}

export const adminMenu: MenuItemConfig[] = [
  { label: 'Home', icon: 'ph:house-bold', path: '/admin' },
  { label: 'Booking', icon: 'ph:calendar-blank-bold', path: '/admin/booking' },
  { label: 'Transaksi', icon: 'ph:receipt-bold', path: '/admin/transactions' },
  { label: 'Lapangan', icon: 'ph:soccer-ball-bold', path: '/admin/field' },
  { label: 'Sewa & Layanan', icon: 'ph:handshake-bold', path: '/admin/service' },
  {
    label: 'Produk',
    icon: 'ph:package-bold',
    path: '/admin/other-product',
  },
  { label: 'Voucher', icon: 'ph:ticket-bold', path: '/admin/voucher', roles: ['owner'] },
  { label: 'Pelanggan', icon: 'ph:users-bold', path: '/admin/customers' },
  { label: 'Loyalty', icon: 'ph:medal-bold', path: '/admin/loyalty' },
  {
    label: 'WhatsApp Tools',
    icon: 'ph:whatsapp-logo-bold',
    path: '/admin/whatsapp',
    roles: ['owner'],
    hideOnMobile: true,
  },
];

export const clientMenu: MenuItemConfig[] = [
  {
    label: 'Home',
    icon: 'mdi:home-outline',
    path: '/',
  },
  {
    label: 'Event',
    icon: 'ph:calendar-dots',
    activeIcon: 'ph:calendar-dots-fill',
    path: '/event',
  },
  {
    label: 'Discovery',
    icon: 'ph:compass',
    activeIcon: 'ph:compass-fill',
    path: '/discovery',
  },
  { label: 'Booking', icon: 'mingcute:calendar-add-line', path: '/booking' },
  { label: 'Transaksi', icon: 'mdi:chart-areaspline', path: '/transactions' },
];

export const communityMenu: MenuItemConfig[] = [
  { label: 'Home', icon: 'ph:house-bold', path: '/host' },
  { label: 'Event', icon: 'ph:calendar-blank-bold', path: '/host/mabar' },
  { label: 'Member', icon: 'ph:users-three-bold', path: '/host/members' },
  { label: 'Profile', icon: 'ph:user-circle-bold', path: '/host/profile-settings' },
  { label: 'Cash Flow', icon: 'ph:currency-circle-dollar-bold', path: '/cash', hideOnMobile: true },
  { label: 'Transaction', icon: 'ph:receipt-bold', path: '/host/transactions', hideOnMobile: true },
  {
    label: 'WhatsApp',
    icon: 'mdi:whatsapp',
    path: '/host/whatsapp',
    hideOnMobile: true,
  },
];
